import { useMemo } from 'react';
import { useStore } from '@nanostores/react';
import { billing } from '@/services/billing';
import { PlanType, Plans } from '@/services/billing/plans';

export type PlanDetails = {
  objectTypeLimit: number;
  baseObjectCount: number;
  baseMeteredObjectRate: string;
};

export function useObjectPlanDetails(): PlanDetails | null {
  const planType = useStore(billing.planType);
  const planNameShortened = useStore(billing.planNameShortened);
  const isTrial = useStore(billing.isTrial);

  return useMemo(() => {
    let plan = Object.values(Plans).find((candidate) => {
      if (candidate.planType !== planType) return false;
      return candidate.planType !== PlanType.Startup || candidate.name === planNameShortened;
    });

    if (isTrial === true) plan = Plans.Essentials;
    if (plan == null) return null;

    return {
      objectTypeLimit: plan.planLimits.objectTypes?.value ?? 2,
      baseObjectCount: plan.includedObjects,
      baseMeteredObjectRate: plan.objectOverageRate ?? '0.009',
    };
  }, [planType, planNameShortened, isTrial]);
}
